<script setup lang="ts">
import { type IconType } from '@/types/components/IconType'
import { EColors } from '@/types/constants/ColorValues'
import BaseButton from './BaseButton.vue'

interface ButtonProps {
    label?: string
    icon?: IconType | string
}

defineProps<ButtonProps>()
defineEmits<{
    (e: 'click', event: MouseEvent): void
}>()
</script>

<template>
    <BaseButton
        class="secondary-button"
        :icon="icon"
        :label="label"
        :type="EColors.SECONDARY"
        @click="$emit('click', $event)" />
</template>
